const m = require('minthril');
const { component } = require('../../component');
const { Modal } = require('../modal');

const Header = component((vnode, emit) => {
  let accountMenuOpen = false;

  function closeAccountMenu () {
    accountMenuOpen = false;
    emit('redraw');
  }

  return {
    view: ({ attrs: {
      user,
      isAdmin,
      impersonating,
      impersonatedAccount,
      freshAccountPreview,
      stoppingFreshAccountPreview,
      onSignIn,
      onSignOut,
      onStopImpersonation,
      onStopFreshAccountPreview
    } }) => m('header.header',
      impersonating && m('div.header__impersonation', [
        m('span', `Viewing ${impersonatedAccount?.displayName || impersonatedAccount?.email || 'account'} (read-only)`),
        m('button.button.button--quiet', { onclick: onStopImpersonation }, 'Exit')
      ]),
      freshAccountPreview && m('div.header__fresh-preview', [
        m('span', 'Temporary account preview · account data is deleted on exit; abandoned previews are cleaned up after expiry'),
        m('button.button.button--quiet', {
          disabled: stoppingFreshAccountPreview,
          onclick: onStopFreshAccountPreview
        }, stoppingFreshAccountPreview ? 'Cleaning up…' : 'Exit preview')
      ]),
      m('h1', m('a.header__brand', { href: '/' }, [
        m('img.header__logo', {
          src: '/images/logo.png',
          alt: ''
        }),
        m('span', 'Spache')
      ])),
      m('nav.header-actions',
        user && m('a.link-button', { href: '/sites' }, 'Sites'),
        user && isAdmin && m('a.link-button', { href: '/admin' }, 'Admin'),
        !user && m('a.link-button', { href: '/how-it-works' }, 'How it works'),
        !user && m('a.link-button', { href: '/docs/pricing' }, 'Pricing'),
        user && m(Modal, {
          isOpen: accountMenuOpen,
          onClose: closeAccountMenu,
          className: `header__account-menu${accountMenuOpen ? ' header__account-menu--open' : ''}`
        }, [
          m('button.header__account-trigger', {
            type: 'button',
            'aria-label': `${user.email || 'Account'} menu`,
            title: user.email || 'Account',
            'aria-expanded': accountMenuOpen,
            onclick: () => {
              accountMenuOpen = !accountMenuOpen;
              emit('redraw');
            }
          }, user.photoURL
            ? m('img.header__avatar', { src: user.photoURL, alt: '' })
            : m('span.header__avatar-fallback', (user.email || 'A').charAt(0).toUpperCase())),
          accountMenuOpen && m('nav.header__account-links', { 'aria-label': 'Account menu' }, [
            m('a', { href: '/account', onclick: closeAccountMenu }, 'Account'),
            m('a', { href: '/account/billing', onclick: closeAccountMenu }, 'Billing'),
            m('a', { href: '/account/developer', onclick: closeAccountMenu }, 'Developer access'),
            m('button', {
              type: 'button',
              onclick: event => {
                closeAccountMenu();
                onSignOut();
              }
            }, 'Sign out')
          ])
        ]),
        !user && m('button.button.button--quiet', { onclick: onSignIn }, 'Sign in')
      )
    )
  };
});

module.exports = { Header };
